import config from "@/const";

export default Object.freeze({
  convert(fromTargetSiteIndex, targetSiteIndex, text) {
    let toSiteType = config.findSiteType(targetSiteIndex);
    let fromSiteType = config.findSiteType(fromTargetSiteIndex);
    let returnText = text;
    if (fromSiteType.boutenFormat) {
      text = text.replace(/:(.+)\|/g, function(tmp, group1) {
        let content = "";
        for (let i = 0; i < group1.length; i++) {
          content += "・";
        }
        return (
          toSiteType.rubiFormat.prefix +
          group1 +
          toSiteType.rubiFormat.middle +
          content +
          toSiteType.rubiFormat.suffix
        );
      });
      text = text.replace(/《《(.+)》》/g, function(tmp, group1) {
        let content = "";
        for (let i = 0; i < group1.length; i++) {
          content += "・";
        }
        return (
          toSiteType.rubiFormat.prefix +
          group1 +
          toSiteType.rubiFormat.middle +
          content +
          toSiteType.rubiFormat.suffix
        );
      });
    }
    returnText = text
      .replace(/:(.*?)\((.+?)\)/g, (tmp, group1, group2) => {
        return this.convertMatchToRuby(toSiteType, group1, group2);
      })
      .replace(/\(ruby:(.*?):(.+?)\)/g, (tmp, group1, group2) => {
        return this.convertMatchToRuby(toSiteType, group1, group2);
      })
      .replace(/<ruby>(.*?)<rt>(.+?)<\/rt><\/ruby>/g, (tmp, group1, group2) => {
        return this.convertMatchToRuby(toSiteType, group1, group2);
      })
      .replace(/\[\[rb:(.+?) > (.+?)\]\]/g, (tmp, group1, group2) => {
        return this.convertMatchToRuby(toSiteType, group1, group2);
      })
      .replace(/\[\[rb:(.+?)>(.+?)\]\]/g, (tmp, group1, group2) => {
        return this.convertMatchToRuby(toSiteType, group1, group2);
      })
      .replace(/\#(.+?)\_\_(.+?)\_\_\#/g, (tmp, group1, group2) => {
        return this.convertMatchToRuby(toSiteType, group1, group2);
      })
      .replace(/[\|｜](.+?)《(.+?)》/g, (tmp, group1, group2) => {
        return this.convertMatchToRuby(toSiteType, group1, group2);
      })
      .replace(/[\|｜](.+?)（(.+?)）/g, (tmp, group1, group2) => {
        return this.convertMatchToRuby(toSiteType, group1, group2);
      })
      .replace(/[\|｜](.+?)\((.+?)\)/g, (tmp, group1, group2) => {
        return this.convertMatchToRuby(toSiteType, group1, group2);
      })
      .replace(/\[#ruby=(.*?)_(.+?)#\]/g, (tmp, group1, group2) => {
        return this.convertMatchToRuby(toSiteType, group1, group2);
      });
    // if (fromTargetSiteIndex != -1) {
    //     returnText = returnText      /* 漢字の連続の後に括弧が存在した場合、一連の漢字をベーステキスト、括弧内の文字をルビテキストとします。 */
    //         .replace(/([一-龠]+)《([^・]+?)》/g, (tmp, group1, group2) => {
    //             return this.convertMatchToRuby(toSiteType, group1, group2)
    //         })
    //         /* ただし丸括弧内の文字はひらがなかカタカナのみを指定できます。 */
    //         .replace(/([一-龠]+)（([ぁ-んァ-ヶ]+?)）/g, (tmp, group1, group2) => {
    //             return this.convertMatchToRuby(toSiteType, group1, group2)
    //         })
    //         .replace(/([一-龠]+)\(([ぁ-んァ-ヶ]+?)\)/g, (tmp, group1, group2) => {
    //             return this.convertMatchToRuby(toSiteType, group1, group2)
    //         })
    // }
    return returnText;
  },

  convertMatchToRuby(targetSiteType, match1, match2) {
    if (!match2.match(/[^・]/g) && targetSiteType.boutenFormat) {
      return (
        targetSiteType.boutenFormat.prefix +
        match1 +
        targetSiteType.boutenFormat.suffix
      );
    }
    return (
      targetSiteType.rubiFormat.prefix +
      match1 +
      targetSiteType.rubiFormat.middle +
      match2 +
      targetSiteType.rubiFormat.suffix
    );
  },

  previewRubiConvert(text) {
    return (
      text
        .replace(
          /&lt;(i[0-9]+)\|([0-9]+)&gt;/g,
          '<img src="https://' +
            "$2" +
            ".mitemin.net/userpageimage/viewimagebig/icode/" +
            "$1" +
            "\" width='100%'/>"
        )
        .replace(/:(.+)\|/g, (tmp, group1) => {
          let content = "";
          for (let i = 0; i < group1.length; i++) {
            content += "・";
          }
          return `<ruby>${group1}<rt>${content}</rt></ruby>`;
        })
        .replace(/《《(.+)》》/g, (tmp, group1) => {
          let content = "";
          for (let i = 0; i < group1.length; i++) {
            content += "・";
          }
          return `<ruby>${group1}<rt>${content}</rt></ruby>`;
        })
        .replace(/:(.+?)\((.+?)\)/g, "<ruby>$1<rt>$2</rt></ruby>")
        .replace(/\(ruby:(.+?):(.+?)\)/g, "<ruby>$1<rt>$2</rt></ruby>")
        .replace(/\[#ruby=(.+?)_(.+?)#\]/g, "<ruby>$1<rt>$2</rt></ruby>")
        .replace(/\#(.+?)\_\_(.+?)\_\_\#/g, "<ruby>$1<rt>$2</rt></ruby>")
        .replace(/[\|｜](.+?)《(.+?)》/g, "<ruby>$1<rt>$2</rt></ruby>")
        .replace(/[\|｜](.+?)（(.+?)）/g, "<ruby>$1<rt>$2</rt></ruby>")
        .replace(/[\|｜](.+?)\((.+?)\)/g, "<ruby>$1<rt>$2</rt></ruby>")
        .replace(/\[\[rb:(.+?) &gt; (.+?)\]\]/g, "<ruby>$1<rt>$2</rt></ruby>")
        .replace(/\[\[rb:(.+?)&gt;(.+?)\]\]/g, "<ruby>$1<rt>$2</rt></ruby>")
          .replace(/\[RB:(.+?),(.+?)\]/g, "<ruby>$1<rt>$2</rt></ruby>")
        /* 漢字の連続の後に括弧が存在した場合、一連の漢字をベーステキスト、括弧内の文字をルビテキストとします。 */
        .replace(/([一-龠]+)《(.+?)》/g, "<ruby>$1<rt>$2</rt></ruby>")
        /* ただし丸括弧内の文字はひらがなかカタカナのみを指定できます。 */
        .replace(
          /([一-龠]+)（([ぁ-んァ-ヶ]+?)）/g,
          "<ruby>$1<rt>$2</rt></ruby>"
        )
        .replace(
          /([一-龠]+)\(([ぁ-んァ-ヶ]+?)\)/g,
          "<ruby>$1<rt>$2</rt></ruby>"
        )
        /* 括弧を括弧のまま表示したい場合は、括弧の直前に縦棒を入力します。 */
        .replace(/[\|｜]《(.+?)》/g, "《$1》")
        .replace(/[\|｜]（(.+?)）/g, "（$1）")
        .replace(/[\|｜]\((.+?)\)/g, "($1)")
        .replaceAll("\n", "<br/>")
    );
  },
});
